import dayjs from 'dayjs';
import { IUserSchedule } from '../../../../store/redux/user/user.interface';

export const formatUserSchedule = (data: IUserSchedule[]) => {
  return data.map((item) => ({
    date: dayjs(item.date).format('YYYY-MM-DD'),
    timestart: item.timestart,
    timeend: item.timeend,
  }));
};